<template>
	<div>
		<vue-particles 
			color="#808080"
			:particleOpacity="0.1"
			:particlesNumber="100"
			shapeType="circle"
			:particleSize="4"
			linesColor="#808080"
			:linesWidth="1"
			:lineLinked="true"
			:lineOpacity="0.9"
			:linesDistance="150"
			:moveSpeed="3"
			:hoverEffect="true"
			hoverMode="grab"
			:clickEffect="true"
			clickMode="push">
		</vue-particles>

		<div class="position-absolute text-header">
			<h1 class="large-header">Hello, I'm <span class="blue">Antonios Tsamourtzis</span>.</h1>
			<h1 class="large-header">I'm a Software Engineer.</h1>
		</div>

		<div class="position-absolute scroll-arrow">
			<img class="mt-3" style="width: 3em;" src="../assets/down-arrow.png" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Header'
	}
</script>